import React, { useContext, useState, useEffect } from 'react';
import { RicosContext, ModalContext } from 'ricos-context';
import { DropdownButton } from 'wix-rich-content-toolbars-ui';
import { POLL_SETTINGS_LAYOUT_MODAL_ID, SETTINGS_TAB, POLL_SETTINGS_MODAL_ID } from '../consts.js';
import { layoutData } from './PollButtonsData.js';
import { SettingsModal } from '../components/settings-modal/settings-modal.js';
import { LayoutGridIcon } from '../assets/icons/LayoutGridIcon.js';
import 'ricos-schema';
import '../assets/icons/LayoutGridIconNew.js';
import '../assets/icons/LayoutListIconNew.js';
import '@wix/design-system';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-ui-components';
import '../tab-navigation-f3eb4402.js';
import '../style-inject.es-e7b07dd7.js';
import '../dataHooks.js';
import '../types.js';
import '../components/settings-modal/design-settings-section.js';
import 'ricos-schema/next';
import '../defaults.js';
import '../helpers.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../components/settings-modal/section.js';
import '../assets/icons/ColorIcon.js';
import '../assets/icons/GradientIcon.js';
import '../assets/icons/ImageIcon.js';
import '../components/settings-modal/layout-settings-section.js';
import 'wix-rich-content-plugin-commons';
import '../assets/icons/LayoutListIcon.js';
import '../components/settings-modal/poll-settings-section.js';

const PollLayoutButton = ({ toolbarItem, id, dataHook, config = {} }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext) || {};
  const node = toolbarItem.attributes.selectedNode;
  const getSelectedLayout = () => {
    var _a, _b, _c;
    return ((_c = (_b = (_a = node == null ? void 0 : node.attrs) == null ? void 0 : _a.layout) == null ? void 0 : _b.poll) == null ? void 0 : _c.type) || "GRID";
  };
  const [referenceElement, setReferenceElement] = useState(null);
  const closeModal = () => modalService.closeModal(id);
  const selectedLayout = layoutData.find(({ commandKey }) => commandKey === getSelectedLayout());
  const Icon = (selectedLayout == null ? void 0 : selectedLayout.icon) || LayoutGridIcon;
  const label = (selectedLayout == null ? void 0 : selectedLayout.text) || "Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid";
  const onLayoutClick = (layout) => {
    var _a;
    (_a = toolbarItem.commands) == null ? void 0 : _a.click({ value: layout });
    closeModal();
  };
  const onCustomizeButtonClick = () => {
    const componentProps = {
      nodeId: toolbarItem.attributes.selectedNode.attrs.id,
      activeTab: SETTINGS_TAB.layout,
      config
    };
    modalService == null ? void 0 : modalService.openModal(POLL_SETTINGS_MODAL_ID, {
      componentProps,
      positioning: { placement: "right" },
      layout: isMobile ? "fullscreen" : "drawer"
    });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService == null ? void 0 : modalService.openModal(id, {
      componentProps: {
        getSelectedLayout,
        onClick: onLayoutClick,
        onCustomizeButtonClick,
        closeModal
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  useEffect(() => {
    !modalService.getModal(POLL_SETTINGS_LAYOUT_MODAL_ID) && modalService.register({
      Component: SettingsModal,
      id: POLL_SETTINGS_LAYOUT_MODAL_ID
    });
  }, []);
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: modalService.isModalOpen(id),
      onClick,
      setRef: setReferenceElement,
      Icon,
      label: t(label),
      tooltip: t("Poll_PollSettings_Tab_Layout_TabName")
    }
  );
};

export { PollLayoutButton };
//# sourceMappingURL=PollLayoutButton.js.map
